import { IconWarningCircle } from "@suse-o11y/icons";
import React, { type FC } from "react";
import { useSelector } from "react-redux";

import { selectTimestampDate } from "../../app/state/view/timeline/TimelineSelectors";
import { DocLink } from "../../components/react/docLink/DocLink";
import { LinkFrom } from "../../components/react/link";
import { Tooltip } from "../../components/react/tooltip/Tooltip";

export const SnapshotIndication: FC = () => {
	const timestamp = useSelector(selectTimestampDate);

	if (!timestamp) {
		return null;
	}

	const tooltip = (
		<div className="p-1 text-13">
			The timeline is currently paused. Whilst traveling back in time is useful when doing an investigation, it also
			means you are not seeing any live data. <DocLink capture="noop" slug="ui-topology-time" text="Learn more" />
		</div>
	);

	return (
		<div
			className="flex w-64 shrink-0 items-stretch gap-x-1 self-stretch text-13"
			data-testid="snapshot-indication"
			data-tourid="snapshot-indication"
		>
			<Tooltip
				overlayStyle={{
					zIndex: 3000,
					maxWidth: "346px",
				}}
				title={tooltip}
			>
				<div className="flex items-center gap-x-2 text-yellow-500">
					<IconWarningCircle className="text-base" />
					You are in time travel mode.
				</div>
			</Tooltip>
			<Tooltip title={<div className="p-1 text-13">Show changes in real-time</div>}>
				<LinkFrom
					className="flex items-center font-medium text-grey-100 underline hover:no-underline"
					from="*"
					search={(search) => ({ ...search, timestamp: undefined })}
				>
					Go live
				</LinkFrom>
			</Tooltip>
		</div>
	);
};
